import { useEffect } from "react";

/**
 * Injects Google Analytics 4 and Meta Pixel scripts on first mount when their
 * IDs are configured via the Admin → Site Content tab. No-ops if IDs are blank.
 * Exposes `window.gtag` and `window.fbq` for downstream event tracking.
 */
export default function AnalyticsPixels({ gaId, metaId }) {
  useEffect(() => {
    if (!gaId || typeof window === "undefined") return;
    if (window.__ve_ga_loaded) return;
    window.__ve_ga_loaded = true;

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", gaId);
  }, [gaId]);

  useEffect(() => {
    if (!metaId || typeof window === "undefined") return;
    if (window.__ve_fbq_loaded) return;
    window.__ve_fbq_loaded = true;

    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */

    window.fbq("init", metaId);
    window.fbq("track", "PageView");
  }, [metaId]);

  return null;
}

/* ---- tiny helpers for downstream event tracking ---- */
export function trackEvent(name, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") window.gtag("event", name, params);
    if (typeof window.fbq === "function") window.fbq("trackCustom", name, params);
  } catch {
    /* swallow */
  }
}

export function trackPurchase(value, currency = "ZAR", orderId) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
      window.gtag("event", "purchase", {
        transaction_id: orderId,
        value,
        currency,
      });
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "Purchase", { value, currency });
    }
  } catch {
    /* swallow */
  }
}

export function trackAddToCart(value, currency = "ZAR", name) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
      window.gtag("event", "add_to_cart", { value, currency, items: [{ item_name: name }] });
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "AddToCart", { value, currency, content_name: name });
    }
  } catch {
    /* swallow */
  }
}
